import apiClient from "@/api/client";
import type { ProjectGroup, ProjectGroupFormData } from "@/features/enterprises/types";

const BASE = "/project-groups/";

export const projectGroupsApi = {
  list: () =>
    apiClient.get<{ data: ProjectGroup[] }>(BASE).then((r) => r.data.data),
  get: (id: string) =>
    apiClient.get<{ data: ProjectGroup }>(`${BASE}${id}/`).then((r) => r.data.data),
  create: (data: ProjectGroupFormData) =>
    apiClient.post<{ data: ProjectGroup }>(BASE, data).then((r) => r.data.data),
  update: (id: string, data: Partial<ProjectGroupFormData>) =>
    apiClient.patch<{ data: ProjectGroup }>(`${BASE}${id}/`, data).then((r) => r.data.data),
  delete: (id: string) => apiClient.delete(`${BASE}${id}/`),
};
